<a *ngIf="tableSortEnabled" class="sortable"
    [class.desc]="tableSortField.direction === 'DESC'"
    [class.asc]="tableSortField.direction === 'ASC'"
    (click)="!disabled && cambiaDirezione()"
    [class.disabled]="disabled">
    <span [ngbTooltip]="tooltip">{{ title }}</span>
    <span class="sort-icon">
        <app-toolkit-bl-icon [cssClass]="'icon icon-desc'" icon="arrow-down-triangle"></app-toolkit-bl-icon>
        <app-toolkit-bl-icon [cssClass]="'icon icon-asc'" icon="arrow-up-triangle"></app-toolkit-bl-icon>
    </span>
</a>
<span *ngIf="!tableSortEnabled" [ngbTooltip]="tooltip">{{ title }}</span>